import { getDataIdsFromContract } from '../shared/utils/dataId';

export const resolvedComponentDataIds = getDataIdsFromContract({
  base: 'resolved-component',
  error: 'error',
  shimmer: 'shimmer'
});
